/*jshint esversion: 8 */
import store from '../components/stores/Store';
import { hostIp, imgHostIp } from "../config/ips";
import { sleep } from '../utils/Sleep';

const fetchPost = async (path, data) => {
  let response;
  try {
    console.log(`----- 开始通讯: `);
    while (
      !store.user.uuid
      && !([  // 登陆类方法
        '/web_public/signin',
        '/web_system_operation/signinWithToken',
        '/web_oauth/signinWithOAuth',
      ].includes(path))
    ) {
      console.log(`----- 等待信息加载-uuid`);
      await sleep(100);
    }
    while (
      !store.user.JWTToken
      && ([
        '/web_system_operation/signinWithToken', // token登陆类方法
      ].includes(path))
    ) {
      console.log(`----- 等待信息加载-JWTToken-path: `, path);
      await sleep(100);
    }
    response = await fetch(`${hostIp}${path}`, {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        authorization: store.user.JWTToken || '',
        marketid: store.marketId || '9999',
        // marketid: store.user.marketId || '9999',
        userid: store.user.uuid
      },
      body: JSON.stringify(data),
    });

    console.log(`----- 通讯返回: `);
    if (response.ok) {
      const rst = await response.json();
      rst.code = rst.code || 'success';
      rst.msg = rst.msg || 'success';
      return rst;
    }
    return {
      code: 'error',
      msg: response.statusText,
    };
  } catch (error) {
    console.error("----- fetchPost-error: ", error);
    return {
      code: 'error',
      msg: '网络超时',
    };
  }
};


export {
  hostIp,
  imgHostIp,
  fetchPost,
};
